function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';
import './ZoomControl.css';

var ZoomControl = /*#__PURE__*/function (_React$Component) {
  _inherits(ZoomControl, _React$Component);

  function ZoomControl(props) {
    var _this;

    _classCallCheck(this, ZoomControl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ZoomControl).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "zoomIn", function () {
      var _this$props = _this.props,
          map = _this$props.map,
          currentZoom = _this$props.currentZoom,
          maxZoom = _this$props.maxZoom;

      if (currentZoom + 1 <= maxZoom) {
        map.setZoom(currentZoom + 1);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "zoomOut", function () {
      var _this$props2 = _this.props,
          map = _this$props2.map,
          currentZoom = _this$props2.currentZoom,
          minZoom = _this$props2.minZoom;

      if (currentZoom - 1 >= minZoom) {
        map.setZoom(currentZoom - 1);
      }
    });

    _this.state = {};
    return _this;
  }

  _createClass(ZoomControl, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          currentZoom = _this$props3.currentZoom,
          minZoom = _this$props3.minZoom,
          maxZoom = _this$props3.maxZoom;
      return React.createElement("div", {
        className: "zoom-control ".concat(this.props.className)
      }, React.createElement("div", {
        className: "ripple plus ".concat(currentZoom === maxZoom ? 'disabled' : ''),
        onClick: this.zoomIn
      }, React.createElement(FontAwesomeIcon, {
        icon: faPlus,
        className: "icon"
      })), React.createElement("div", {
        className: "ripple minus ".concat(currentZoom === minZoom ? 'disabled' : ''),
        onClick: this.zoomOut
      }, React.createElement(FontAwesomeIcon, {
        icon: faMinus,
        className: "icon"
      })));
    }
  }]);

  return ZoomControl;
}(React.Component);

export default ZoomControl;